<template>
  <div class="link-supplier">
    <el-page-header @back="goBack" content="供应商管理 >关联供应商">
    </el-page-header>
    <el-form ref="form" :model="form" label-width="100px">
      <el-form-item label="材料Id">
        {{ this.form.rawMaterialId }}
      </el-form-item>
      <el-form-item label="供应商名称">
        <el-select v-model="form.supplierId" size="small" filterable placeholder="请选择">
          <el-option v-for="item in supplierList" :key="item.id" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="预估采购价">
        <el-input v-model="form.estimatePurchaseUnitPrice" size="small" style="width: 217px;"></el-input>
      </el-form-item>
      <el-form-item label="备注">
        <el-input v-model="form.remark" size="small" style="width: 217px;"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button @click="goBack" size="small" style="width: 80px;">取消</el-button>
        <el-button type="primary" @click="onSubmit" size="small" style="width: 80px;">确定</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
  import {
    supplierModules
  } from '@r'
  export default {
    data() {
      return {
        form: {
          rawMaterialId: this.$route.query.rawMaterialId,
          supplierId: "",
          estimatePurchaseUnitPrice: "",
          remark: ""
        },
        supplierList: []
      }
    },
    activated() {
      this.form = {
        rawMaterialId: this.$route.query.rawMaterialId,
        supplierId: "",
        estimatePurchaseUnitPrice: "",
        remark: ""
      };
      this.getSupplierList();
    },
    methods: {
      goBack() {
        this.$router.go(-1);
      },
      onSubmit() {
        if (this.form.supplierId == "") {
          this.$message({
            type: 'error',
            message: '请选择供应商'
          });
          return;
        }
        supplierModules.editSupplierProductRelation(this.form).then((res) => {
          if (res.result !== 1) {
            this.$message({
              type: 'error',
              message: res.message ? res.message : '关联供应商失败'
            });
            return
          }
          this.$message({
            type: 'success',
            message: "关联成功"
          });
          this.goBack();
        }).catch((err) => {
          this.$message({
            type: 'error',
            message: err.message ? err.message : '未知错误'
          });
        });
      },
      getSupplierList() {
        supplierModules.list({}).then((res) => {
          if (res.result !== 1) {
            this.$message({
              type: 'error',
              message: res.message ? res.message : '获取供应商列表失败'
            });
            return
          }

          this.supplierList = res.ldata;
        }).catch((err) => {
          this.$message({
            type: 'error',
            message: err.message ? err.message : '未知错误'
          });
        })
      }
    }
  }
</script>

<style lang="scss">
  .el-form {
    margin-top: 20px;
  }
</style>
